import { FC, useEffect, useState, useCallback } from "react";
import Layout from "../layout/Layout";
import { useTranslation } from "react-i18next";
import DataTable from "./table/Table";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  dataTableActions,
  fetchCerealTypeDataTableDictionary,
  fetchDataColumns,
} from "../../redux/actions/dataTable/DataTableAsyncActions";
import SidebarDataFilters from "./table/MenuOptions/options/filters/filtersSideBar/SideBarFilters";
import {
  fetchCropsServiceDataTableFilter,
  fetchSBActionsNames,
  fetchSBSites,
  fetchSBUserNames,
} from "../../redux/actions/dataTable/DataFiltersAsyncActions";
import { State } from "../../redux/slices";
import { Modal } from "@mui/material";
import { ExportModal } from "./table/MenuOptions/options/export/ExportBody";

const DataT: FC = () => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [hasInitialized, setHasInitialized] = useState(false);

  const { filtersSelected } = useSelector(
    (state: State) => state.DataFiltersReducer
  );
  const { exportModalVisible } = useSelector(
    (state: State) => state.DataExportReducer
  );

  const { cerealInformation } = useSelector(
    (state: State) => state.DataTableReducer
  );

  const initData = useCallback(() => {
    dispatch(fetchDataColumns());
    dispatch(dataTableActions());
    dispatch(fetchCerealTypeDataTableDictionary());
  }, [dispatch]);

  const initDataFilters = useCallback(() => {
    dispatch(fetchCropsServiceDataTableFilter());
    dispatch(fetchSBSites());
    dispatch(fetchSBUserNames());
    dispatch(fetchSBActionsNames());
  }, [dispatch]);

  const ExportModalBody = ExportModal();

  useEffect(() => {
    if (!hasInitialized) {
      initData();
      if (filtersSelected === 0) {
        initDataFilters();
      }
      setHasInitialized(true);
    }
  }, [hasInitialized, filtersSelected, initData, initDataFilters]);

  useEffect(() => {
    if (hasInitialized && cerealInformation && cerealInformation.length === 0) {
      initData();
    }
  }, [hasInitialized, cerealInformation, initData]);

  const dataComponents = () => {
    return (
      <div style={{ width: "96%" }}>
        <div role="none" className="fleet-table-container-data">
          <DataTable />
          <div className="data-table-sidebar-styles">
            <SidebarDataFilters />
          </div>
        </div>
        <Modal open={exportModalVisible}>
          <div>{ExportModalBody}</div>
        </Modal>
      </div>
    );
  };
  return <Layout title={t("Data.title")} component={dataComponents()} />;
};

export default DataT;
